import { determineFullTradeData } from "@/lib/agGridColDefs/colDefGlobalHelpers";
import { returnFormattedDate } from "@/lib/globalFormatterHelper";

const ReferenceRateTooltip = (params: any) => {
  const fullTradeData = determineFullTradeData(params);

  if (
    !fullTradeData.referenceRates ||
    fullTradeData.referenceRates.length == 0 ||
    !fullTradeData.referenceRates[0].referenceRateCode ||
    !fullTradeData.referenceRates[0].referenceRate ||
    fullTradeData.referenceRates[0].referenceRate.length == 0 ||
    !fullTradeData.referenceRates[0].referenceRate[0].date
  ) {
    return;
  }

  const indexToRender = fullTradeData.referenceRates[0].referenceRateCode;
  const rawDate = fullTradeData.referenceRates[0].referenceRate[0].date;
  const dateToRender = returnFormattedDate(rawDate);

  return (
    <div className="bg-gray-300 px-2 py-1 shadow-lg dark:bg-[#171717]">
      <div className="gap-2-1 flex flex-col">
        <div>Index: {indexToRender}</div>
        <div>Date: {dateToRender}</div>
      </div>
    </div>
  );
};

export default ReferenceRateTooltip;
